// extracted by mini-css-extract-plugin
module.exports = {"aside":"VAside_aside_1t3My","container":"VAside_container_ASG60","close":"VAside_close_ecvKH","blur":"VAside_blur_3OMGM","content":"VAside_content_1ddtr"};